export class AuthRequest {
  program: string;
  procedure: string;
  user: string;
  password: string;

  constructor(user: string, password: string, program?: string, procedure?: string) {
    this.program = program || "bas/auth/auth.p"
    this.procedure = procedure || "pi-login"
    this.user = user
    this.password = password
  }

}
